import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/client';

export default function Export() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleExport = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/api/admin/export', {
        responseType: 'blob',
      });

      // 从响应头读取后端给的中文文件名(RFC 5987 格式)
      let filename = '书院分配结果.xlsx';
      const disposition = res.headers['content-disposition'];
      if (disposition) {
        const match = disposition.match(/filename\*=UTF-8''([^;]+)/);
        if (match) {
          filename = decodeURIComponent(match[1]);
        }
      }

      // 触发浏览器下载
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (e: any) {
      // 后端返回 blob,但出错时是 JSON。需要解析 blob 为 JSON
      let detail = '导出失败,请重试';
      if (e.response?.data instanceof Blob) {
        try {
          const text = await e.response.data.text();
          const parsed = JSON.parse(text);
          detail = parsed.detail || detail;
        } catch {
          // JSON 解析失败,用默认错误信息
        }
      } else if (e.response?.data?.detail) {
        detail = e.response.data.detail;
      } else if (e.message) {
        detail = e.message;
      }
      setError(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-800">导出名单</h1>
          <button onClick={() => navigate('/admin/dashboard')}
            className="text-sm text-gray-500 hover:text-gray-700">← 返回</button>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-sm text-center">
          <div className="text-6xl mb-4">📊</div>
          <h2 className="text-lg font-semibold text-gray-800 mb-2">导出最新分配名单</h2>
          <p className="text-gray-500 mb-2">下载 Excel 文件,包含:</p>
          <ul className="text-sm text-gray-500 mb-8 space-y-1">
            <li>• 总览(全员一表)</li>
            <li>• 各书院独立 Sheet,含建议房号</li>
            <li>• 配对名单(室友配对统计)</li>
            <li>• 未答题学生名单</li>
          </ul>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-4">
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}

          <button
            onClick={handleExport}
            disabled={loading}
            className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-indigo-700 disabled:opacity-50"
          >
            {loading ? '导出中...' : '下载 Excel 名单'}
          </button>

          <p className="text-xs text-gray-400 mt-4">
            自动导出最近一次运行的分配结果
          </p>
        </div>
      </div>
    </div>
  );
}
